(function () {
  "use strict";
  var d = document;
  // Only now does anything become animatable. Until this line runs the page is
  // fully visible - no JS, no hidden content.
  d.documentElement.classList.add('mh-anim');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function observe(nodes, attr) {
    if (!('IntersectionObserver' in window) || reduce.matches) {
      Array.prototype.forEach.call(nodes, function (n) { n.setAttribute(attr, 'in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.setAttribute(attr, 'in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  var logos = d.querySelectorAll('[data-mh-logo]');
  Array.prototype.forEach.call(logos, function (l) { l.setAttribute('data-reveal', ''); });
  observe(logos, 'data-reveal');

  // Reveal the main content sections, but never the first one - the hero must not
  // fade in under the visitor.
  var sections = d.querySelectorAll('#MainContent .shopify-section');
  Array.prototype.forEach.call(sections, function (s, i) {
    if (i === 0) return;
    s.setAttribute('data-mh-reveal', '');
  });
  observe(d.querySelectorAll('[data-mh-reveal]'), 'data-mh-reveal');
})();
